export const tokenExpiredCode = 'tokenExpired';
export const appIsReadyCode = 'viewLoaded';
export const generalErrorCode = 'generalError';
export const mobileAppInitialPath = 'mobile';
export const notAvailable = 'viewNotAvailable';
export const loadUserSessionDelay = 1000;
